var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8InTransit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#26aa99",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5v2h7v2h-6v2h4v2h-4v5h2c0,1.657 1.343,3 3,3c1.657,0 3,-1.343 3,-3h5h1c0,1.657 1.343,3 3,3c1.657,0 3,-1.343 3,-3h2v-5l-3,-6h-4v-2zM16,8.75h2.91797l2.125,4.25h-5.04297zM6,16.75c0.689,0 1.25,0.561 1.25,1.25c0,0.689 -0.561,1.25 -1.25,1.25c-0.689,0 -1.25,-0.561 -1.25,-1.25c0,-0.689 0.561,-1.25 1.25,-1.25zM18,16.75c0.689,0 1.25,0.561 1.25,1.25c0,0.689 -0.561,1.25 -1.25,1.25c-0.689,0 -1.25,-0.561 -1.25,-1.25c0,-0.689 0.561,-1.25 1.25,-1.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8InTransit);
export default __webpack_public_path__ + "static/media/icons8-in-transit.2a62b0466580e8c9114da6cb2d78782d.svg";
export { ForwardRef as ReactComponent };